module.exports = __webpack_public_path__ + "static/media/brick.fd720fc8.png";